<template>
  <svg :class="'icon'" width="16" height="18" viewBox="0 0 16 22" fill="none">
    <path
      d="M12 6.66667H14.6667V18C14.6667 19.1 13.7667 20 12.6667 20H3.33333C2.23333 20 1.33333 19.1 1.33333 18V6.66667H4V17.3333H6.66667V6.66667H9.33333V17.3333H12V6.66667ZM0 2.66667H16V5.33333H0V2.66667ZM5.33333 0H10.6667V1.33333H5.33333V0Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: '#000000',
  },
})
</script>

<style lang="scss" scoped></style>
